export default {
  apiEndpoint: process.env.REACT_APP_API_URI,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  sentryDebugMode: process.env.REACT_APP_SENTRY_DEBUG_MODE,
  appName: process.env.REACT_APP_APP_NAME,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID,
};
